module.exports = __webpack_public_path__ + "img/screenshot1.a445b8e6.png";